import React from 'react'
import {useGetAdaptiveStyle} from '../hooks/useGetAdaptiveStyle'
import {adaptiveStyleConfig} from './consts'
import styles from "./LetterButton.scss"

type Props = {
  isActive: boolean
  symbol: string
  onClick: (letter: string) => void
}

export const LetterButton: React.FC<Props> = (props) => {
  const {isActive, symbol, onClick} = props
  const {style} = useGetAdaptiveStyle(adaptiveStyleConfig)

  const onClickHandle = () => {
    if (isActive) {
      onClick(symbol)
    }
  }

  return (
    <>
      {isActive
        ? <div onClick={onClickHandle} className={styles.letter} style={style}>{symbol}</div>
        : <div className={styles.letteroff} style={style}>{symbol}</div>
      }    
    </>
  )
}
